import { useTranslation } from 'next-i18next'
import { makeStyles, Container, Grid } from '@material-ui/core'
import T from '../home-new/tokens'
import Reveal from '../home-new/Reveal'

// Section 7 — "เริ่มต้นใช้งาน SHIPPOP BUSINESS ง่ายๆ ใน 3 ขั้นตอน".
// Mirrors the /new StepsNew layout (illustration + blue pill title + desc).
const steps = [
  { id: 's1', img: '/static/img/home-business/steps/01.png' },
  { id: 's2', img: '/static/img/home-business/steps/02.png' },
  { id: 's3', img: '/static/img/home-business/steps/03.png' },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0',
    background: T.color.surface,
    [theme.breakpoints.down('sm')]: {
      padding: '44px 0',
    },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 48px',
    '& span': { color: T.color.brand },
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      margin: '0 0 28px',
    },
  },
  stepCard: {
    textAlign: 'center',
    padding: '0 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
  },
  // Fixed-height image frame so every column's illustration occupies the same
  // vertical space regardless of the source aspect ratio (steps 01/02 are
  // square, step 03 is 3:2). object-fit:contain keeps each illustration whole
  // (no crop); the uniform box height lines up the blue pill titles and the
  // descriptions row-by-row across all 3 steps — matching the design.
  imgBox: {
    width: '100%',
    maxWidth: 340,
    height: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: { maxWidth: 300, height: 240 },
  },
  stepImg: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: T.radius.lg,
    transition: 'transform 0.4s ease',
    '&:hover': { transform: 'translateY(-8px)' },
  },
  stepTitle: {
    fontFamily: T.font.heading,
    fontSize: 20,
    fontWeight: 500,
    margin: '20px 0 8px',
    background: T.gradient.blue,
    color: T.color.onBrand,
    display: 'inline-block',
    padding: '10px 28px',
    borderRadius: T.radius.pill,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      padding: '8px 20px',
    },
  },
  stepDesc: {
    fontFamily: T.font.body,
    fontSize: 15,
    color: T.color.muted,
    lineHeight: 1.6,
    margin: '14px auto 0',
    maxWidth: 280,
    [theme.breakpoints.down('sm')]: { fontSize: 14 },
  },
}))

const StepsBiz = () => {
  const classes = useStyles()
  const { t } = useTranslation('business')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            {t('steps.headingPre')} <span>SHIPPOP BUSINESS</span> {t('steps.headingPost')}
          </h2>
        </Reveal>
        <Grid container spacing={4} justify="center">
          {steps.map((step, i) => (
            <Grid item xs={12} sm={4} key={step.id}>
              <Reveal delay={i * 0.15}>
                <div className={classes.stepCard}>
                  <div className={classes.imgBox}>
                    <img
                      src={step.img}
                      alt={t(`steps.items.${step.id}.title`)}
                      className={classes.stepImg}
                      loading="lazy"
                    />
                  </div>
                  <div className={classes.stepTitle}>{t(`steps.items.${step.id}.title`)}</div>
                  <p className={classes.stepDesc}>{t(`steps.items.${step.id}.desc`)}</p>
                </div>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  )
}

export default StepsBiz
